import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    templateUrl: "copyright.component.html",
    selector: "copyright",
    styleUrls: ["./copyright.component.scss"],
    imports: [TranslatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class CopyrightComponent implements OnInit {

	public year!: number;

	ngOnInit(): void {
		this.year = (new Date()).getFullYear();
	}

}
